import { HashRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import PaperTradeMERN from "./pages/PaperTradeMERN";
import { ImageEditor } from "./pages/ImageEditor";
import { FlowInTheFieldFrontend } from "./pages/FlowInTheFieldFrontend";
import AboutMe from "./pages/AboutMe";
import Hamburger from "./components/Hamburger";
import NavMenuModal from "./components/NavMenuModal";
import { useState } from "react";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <HashRouter>
      <ScrollToTop />
      <Hamburger handleHamburgerClick={() => setIsExpanded(!isExpanded)} />
      {isExpanded && <NavMenuModal hideNavMenu={() => setIsExpanded(!isExpanded)} />}
      <Routes>
        <Route path="imageeditor" element={<ImageEditor />} />
        <Route path="papertrademern" element={<PaperTradeMERN />} />
        <Route
          path="flowinthefieldfrontend"
          element={<FlowInTheFieldFrontend />}
        />
        <Route path="about" element={<AboutMe />} />
        <Route path="/" element={<Home />} />
      </Routes>
    </HashRouter>
  )
}

export default App;
